import {h} from 'preact';
import {useEffect, useRef} from 'preact/hooks';
import ImageLoader from '../image-loader/image-loader';

const imgLoader = new ImageLoader();

export default function LazyLoadedImage(props) {
  const selfRef = useRef();
  useEffect(() => {
    imgLoader.observeImage(selfRef.current);
  });
  return (
    <img {...props} ref={selfRef} />
  );
}

export function LazyLoadedBackgroundImage(props) {
  const selfRef = useRef();
  useEffect(() => {
    imgLoader.observeImage(selfRef.current);
  });
  const TagName = props.tagName;
  return (
    <TagName {...props} ref={selfRef}>
      {props.children}
    </TagName>
  );
}
